import { Button, Stack, styled } from '@mui/material'
import { memo } from 'react'
import { CreateOrderComponent } from './CreateOrder'
import ModalLink from 'components/ModalLink'
import { useAtom } from 'jotai'
import { mobileDisplayCreateOrder } from './atoms'
import { OrderDirection } from 'store/spot/types'
import { useAppDispatch } from 'store'
import { updateOrderDirection } from 'store/spot/actions'

const HandleBar = styled(Stack)`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background-color: rgba(22, 25, 30, 1);
`
const HandleButton = styled(Button)`
  flex: 1;
  height: 40px;
  font-weight: 600;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  border-radius: 20px;
`
const BuyButton = styled(HandleButton)`
  background-color: rgba(14, 203, 129, 1);
`
const SellButton = styled(HandleButton)`
  background-color: rgba(246, 70, 93, 1);
`

export const MobileCreateOrder = memo(() => {
  const dispatch = useAppDispatch()

  const [isIn, setIsIn] = useAtom(mobileDisplayCreateOrder)
  const handleClick = (direction: OrderDirection) => {
    setIsIn(true)
    dispatch(updateOrderDirection(direction))
  }
  return (
    <HandleBar>
      <BuyButton
        onClick={() => {
          handleClick(OrderDirection.LONG)
        }}
      >
        Buy
      </BuyButton>
      <SellButton
        onClick={() => {
          handleClick(OrderDirection.SHORT)
        }}
      >
        Sell
      </SellButton>

      <ModalLink
        isIn={isIn}
        onClose={() => {
          setIsIn(false)
        }}
        maskClose={false}
      >
        <CreateOrderComponent />
      </ModalLink>
    </HandleBar>
  )
})
